/**
 * Kleine Symbole fuer die Schalter oben links (Rueckmeldung vom 13.10.2026:
 * "einfach nur so ein typisches Ton-Symbol").
 *
 * Eigene Zeichnungen in einfachen Linien, keine Schrift und keine fremde
 * Symbolsammlung. Sie nehmen die Textfarbe des Knopfes an (currentColor),
 * damit Hover und Zustand weiter ueber das CSS laufen.
 */

const RAHMEN = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

/** Lautsprecher - mit Schallwellen, oder durchgestrichen. */
export function TonSymbol({ an }: { an: boolean }) {
  return (
    <svg {...RAHMEN}>
      <path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor" fillOpacity={0.25} />
      {an ? (
        <>
          <path d="M16.5 9a4 4 0 0 1 0 6" />
          <path d="M19 6.5a7.5 7.5 0 0 1 0 11" />
        </>
      ) : (
        <path d="M3 3l18 18" />
      )}
    </svg>
  );
}

/** Vier Ecken - nach aussen zum Vergroessern, nach innen zum Verlassen. */
export function VollbildSymbol({ aktiv }: { aktiv: boolean }) {
  return (
    <svg {...RAHMEN}>
      {aktiv ? (
        <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" />
      ) : (
        <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
      )}
    </svg>
  );
}

/** Die weisse Fahne zum Aufgeben. */
export function FahneSymbol() {
  return (
    <svg {...RAHMEN}>
      <path d="M6 21V3" />
      <path
        d="M6 4c3-1.5 5 1.5 8 0s4-1 5-0.5v8c-1-0.5-2-1-5 0.5s-5-1.5-8 0"
        fill="currentColor"
        fillOpacity={0.9}
      />
    </svg>
  );
}
